import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { format, parse } from "date-fns";
import { last } from "ramda";

dayjs.extend(utc);

export const formatStartDateEndDate = (arrayOfDateObjs, requiredformat) => {
  return arrayOfDateObjs?.map((dateObj) =>
    dayjs(dateObj).format(requiredformat)
  );
};

export const isSomething = (data) => {
  if (data === null || data === undefined) return false;

  if (typeof data === "number") return true;

  if (typeof data === "string" && data.length === 0) return false;

  if (typeof data === "object" && Object.keys(data).length === 0) return false;

  if (Array.isArray(data) && data.length === 0) return false;

  return true;
};

export const roundToNearestQuarterHour = (minutes) => {
  const roundingFactor = 15;
  const roundedMinutes = Math.ceil(minutes / roundingFactor) * roundingFactor;
  return roundedMinutes;
};

export const convertMinutesToRoundedDecimalHours = (totalMins) => {
  const roundedMinutes = roundToNearestQuarterHour(totalMins);
  const hours = roundedMinutes / 60;
  return hours.toFixed(2);
};

export const getProjectStartAndEndDate = (milestones) => {
  const milestoneTasksDates = milestones
    ?.map((m) => m?.tasks)
    ?.flat()
    ?.map((t) => [t?.startDate, t?.endDate])
    ?.flat()
    ?.sort((a, b) => new Date(a) - new Date(b));

  const milestoneStartDate = milestoneTasksDates[0];
  const milestoneEndDate = last(milestoneTasksDates);

  const startDateFormatted = dayjs
    .utc(milestoneStartDate)
    .format("MMMM D, YYYY");
  const endDateFormatted = dayjs.utc(milestoneEndDate).format("MMMM D, YYYY");

  const projectDateRange = `${startDateFormatted} - ${endDateFormatted}`;
  return projectDateRange;
};

export const giveNumber = (val) => {
  return Number(val) || 0;
};
export const formatNumberSafe = (input) => {
  let number = Number(input) || 0;

  if (typeof input == "string") {
    number = parseFloat(input.replace(/,/g, ""));
  }

  if (isNaN(number)) return "0.00";

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export const formatNumber = (input) => {
  let number = Number(input) || 0;

  if (isNaN(number)) return "0.00";

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export const getCompanyNameById = (companies, companyID) => {
  const company = companies?.find((comp) => comp.companyID === companyID);
  return company ? company.companyName : "N/A";
};

export const getFormattedDate = (date) => {
  const formattedDate = date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });

  return formattedDate;
};

export const formatDateDashSeparated = (date, dateFormat = "MM/dd/yyyy") => {
  // will be formatted to M/d/yyyy
  if (!date) return "";
  const parsed = parse(date, "yyyy-MM-dd", new Date());

  return format(parsed, dateFormat);
};

export const formatDate = (date, dateFormat = "MM/dd/yyyy") => {
  if (!date) return "";
  return format(new Date(date), dateFormat);
};

// Helper: format as MM-DD-YYYY
export const formatDateMDY = (date) => {
  const mm = String(date.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(date.getUTCDate()).padStart(2, "0");
  const yyyy = date.getUTCFullYear();
  return `${mm}-${dd}-${yyyy}`;
};

export const getFirstWord = (str) => str.trim().split(/\s+/)[0].toLowerCase();
